// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import store from '@/store'
// import util from './util'
import i18n from './tools/i18n'
import Vant from 'vant'

// import FastClick from 'fastclick'
import axios from 'axios'
import Api from '@/api'

// import COS from 'cos-js-sdk-v5'
import call from '@/callApp.js'

import base from '@/assets/js/base.js'

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import { Button } from 'vant';
import 'vant/lib/vant-css/index.css'
import '@/assets/css/reset.css'
//滑动删除
import { CellSwipe } from 'mint-ui';
Vue.component('mt-cell-swipe', CellSwipe);
import { Cell } from 'mint-ui';
import { Swipe, SwipeItem } from 'vant';
Vue.component('mt-cell', Cell);
Vue.use(Vant);
Vue.use(Swipe).use(SwipeItem);
//下拉加载更多
// import 'muse-components/styles/base.less'
import infiniteScroll from 'muse-components/infiniteScroll'
import { list, listItem} from 'muse-components/list'
Vue.component(infiniteScroll.name, infiniteScroll)
Vue.component(list.name, list)
Vue.component(listItem.name, listItem)
//定义全局组件
import normalHeader from '@/components/normalHeader.vue'
import buttonHeader from '@/components/buttonHeader.vue'
import searchHeader from '@/components/searchHeader.vue'
import loadingSpinner from '@/components/loadingSpinner.vue'
import firstLoading from '@/components/firstLoading.vue'
Vue.component('normal-header', normalHeader);
Vue.component('button-header', buttonHeader);
Vue.component('search-header', searchHeader);
Vue.component('loading-spinner', loadingSpinner);
Vue.component('firstLoading', firstLoading);

Vue.config.productionTip = false

const FastClick = require('fastclick')
FastClick.attach(document.body)

Vue.prototype.$Api = Api
Vue.prototype.$call = call
Vue.prototype.$base = base
Vue.prototype.$http = axios



Vue.mixin({
  methods: {
   setStorage(name,content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
   },
   getStorage(name) {
     if (!name) return;
     return window.localStorage.getItem(name);
   },
   removeStorage(name) {
     if (!name) return;
     window.localStorage.removeItem(name)
   },
   removeSessionStorage(name) {
    if (!name) return;
    window.sessionStorage.removeItem(name)
  }
  }
})


//每次跳转到新页面时，都从最顶部开始显示
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js